module.exports = __webpack_public_path__ + "static/img/4006_phase_function_Paper_PointsHejduk_Prediction.12274d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4006_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 5SLh
// module chunks = 0